module.exports = __webpack_public_path__ + "static/isupport-0dcc4d178cc94a1b7bab538390effc13.png";